import { render, staticRenderFns } from "./SalaryEffectTypeView.vue?vue&type=template&id=5b201e30&"
import script from "./SalaryEffectTypeView.vue?vue&type=script&lang=js&"
export * from "./SalaryEffectTypeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports